﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateLoading = void 0;
const com = require("../com/tmpls");
const StatePaged_1 = require("./abstracts/StatePaged");
class StateLoading extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageLoading, "ValidatorX loading...", false);
        this._sid = "";
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.start.call(this);
        });
    }
}
exports.StateLoading = StateLoading;
StateLoading.StateName = "loading";
//# sourceMappingURL=StateLoading.js.map